import { allZeroesGuid } from "../../Utils";
import { ChildEntityHydrationParams } from "../../Utils";
import { TableQueryFilter } from "../../common";

export const ROOT_RESOURCE_ID = allZeroesGuid;

export const VENDOR_RESOURCE_S3_DIRECTORY_KEY = "partnerAlignResources";

export class VendorResource {
	id = "";
	name = "";
	is_folder = false;
	mime_type: null | string = null;
	file_key: null | string = null;
	parent_dir_id = "";
	vendor_company_id = "";
	vendor_user_id = "";
	updated: Date = new Date();
	created: Date = new Date();
	thumbnail: string | null = null;
	sharing_details: VendorResourcesSharingDetails;
	total_views = 0;
	total_downloads = 0;
	vendor_company_name = "";
	constructor(
		name: string,
		is_folder = false,
		mime_type: null | string = null,
		file_key: null | string = null,
		parent_dir_id = "",
		sharing_details: VendorResourcesSharingDetails,
		total_views = 0,
		total_downloads = 0
	) {
		this.name = name;
		this.is_folder = is_folder;
		this.mime_type = mime_type;
		this.file_key = file_key;
		this.parent_dir_id = parent_dir_id;
		this.sharing_details = sharing_details;
		this.total_views = total_views;
		this.total_downloads = total_downloads;
	}
}
export enum VendorResourceSharingType {
	PRIVATE = "private",
	JOINEDPARTNERS = "joined_partners",
	TIERSANDPARTNERS = "tiers_and_partners"
}
export interface VendorResourcesSharingDetails {
	sharing_type: VendorResourceSharingType;
	whitelisted_partner_ids: string[];
	whitelisted_tier_ids: string[];
}

export class GetVendorResourcesResponse {
	data: VendorResource[] = new Array<VendorResource>();
}

export class GetVendorResourcePathsResponse {
	data: VendorResource[] = new Array<VendorResource>();
}

export class AddVendorResourcesRequest {
	resources: VendorResource[] = new Array<VendorResource>();
	replace_existing = false;
}

export class VendorResourceAnalyticsRequest {
	activity_type: "download" | "view" = "view";
}

export class AddVendorResourcesResponse {
	data: VendorResource[] = new Array<VendorResource>();
}

export interface DeleteVendorResourceResponse {
	deleted: boolean;
}

export enum VendorResourceUploadStep {
	UPLOAD_FILES = 0,
	PREVIEW_FILES = 1
}

export interface VendorResourceBreadcrumb {
	name: string;
	onClick: () => void;
}

export interface VendorResourceDownloadResponse {
	download_url: string;
}

export enum VendorResourceMode {
	ADD = "add",
	EDIT = "edit"
}

export interface VendorEditFolderRequest {
	name: string;
	parent_dir_id: string;
	sharing_details: VendorResourcesSharingDetails;
}
export class VendorResourceTierGetRequest {
	keywords?: string | null = null;
	limit = 0;
	tier_id: string;
	included_child_entities: ChildEntityHydrationParams[] =
		new Array<ChildEntityHydrationParams>();
	filters: TableQueryFilter[] = new Array<TableQueryFilter>();

	constructor(
		tier_id: string,
		filters?: TableQueryFilter[],
		keywords?: string | null,
		included_child_entities?: ChildEntityHydrationParams[],
		limit?: number
	) {
		this.filters = filters || [];
		this.keywords = keywords || "";
		this.included_child_entities = included_child_entities || [];
		this.limit = limit || 100;
		this.tier_id = tier_id;
	}
}
export enum ResourceSelectType {
	TIER = "tier",
	PARTNER = "partner"
}
export interface ResourcePartnersAndTiersSelect {
	value: string;
	name: JSX.Element;
	title: string;
}
export interface VendorStopSharingRequest {
	id: string;
	parent_dir_id: string;
	sharing_details: VendorResourcesSharingDetails;
}
